/*
  Helper function for creating action creators (...yep.)
  Takes two arguments, a (string) type and a payload-getter function.
  Ensures these are of the proper type and constructs a standard-format
  action using them.
*/

type GetPayload<A extends unknown[] = unknown[]> = (...args: A) => unknown;

const makeEmptyObject: GetPayload = () => ({});

export default function makeActionCreator<A extends unknown[]>(
  type: string,
  getPayload: GetPayload<A> = makeEmptyObject,
) {
  if (typeof type !== "string") {
    throw new Error(`Invalid type: ${type}`);
  }

  if (typeof getPayload !== "function") {
    throw new Error(`Invalid getPayload: ${getPayload}`);
  }

  return (...args: A) => ({ type, payload: getPayload(...args) });
}
